<template>
  <div class="insights-wrapper" v-if="!isLoading">
    <BgModalChat
      @close="
        background.modal = false;
        background.text = '';
        background.element = '';
      "
      :background="background"
      v-if="background.modal"
      @result="setResult"
    />
    <div v-if="listMode">
      <List
        :items="insights"
        headers="headers"
        :newInsight="addInsight"
        :select="selectInsight"
      />
    </div>
    <div v-if="!listMode" class="insight">
      <div style="width: 150px">
        <p
          style="margin: 20px 0px; cursor: pointer; font-size: 12pt"
          @click="listMode = true"
        >
          <u>Back to Insights list</u>
        </p>
      </div>
      <div>
        <h2
          class="title"
          @click="showInput"
          style="cursor: pointer; min-height: 1em; min-width: 200px"
          v-if="!editName"
          v-bg-typography="'h2'"
        >
          {{ insightTitle }}
        </h2>
        <input
          v-if="editName"
          ref="insightName"
          id="insightName"
          type="text"
          v-model="selectedInsight.title"
          @blur="
            editName = false;
            saveInsight();
          "
        />
      </div>
      <div class="details" v-if="!suggestionMode">
        <div class="buttons">
          <div style="display: flex; align-items: center">
            <div class="button" id="add" @click="deleteInsight">
              <bg-icon name="fdelete"></bg-icon>
            </div>

            <div class="button" id="upload">
              <bg-icon name="fupload"></bg-icon>
              <input
                ref="imageRef"
                type="file"
                @change="onFileChange"
                accept="image/*"
                style="
                opacity: 0;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;
              "
              />
            </div>
            <p
              style="margin: 0; padding: 0; cursor: pointer"
              v-if="
                selectedInsight.highlight_url &&
                  selectedInsight.highlight_url !=
                    '/images/fallback/default.jpg'
              "
              @click="openImage"
            >
              <u>Image uploaded</u>
            </p>
          </div>
          <div>
            <bg-button
              text="Auto explanation"
              variant="secondary"
              @click="explain"
              style="margin-right: 10px;"
              :isLoading="loading_explanation"
            ></bg-button>
            <bg-button
              text="Auto summary"
              variant="secondary"
              :isLoading="loading_summary"
              @click="summarize"
              style="margin-right: 10px;"
              v-if="
                selectedInsight.explanation &&
                  selectedInsight.explanation != '<p></p>'
              "
            ></bg-button>

            <bg-button
              text="Auto suggestions"
              variant="secondary"
              @click="generateSuggestion"
              :isLoading="loading_suggestion"
              v-if="
                selectedInsight.explanation &&
                  selectedInsight.explanation != '<p></p>'
              "
            ></bg-button>
          </div>
        </div>
        <div
          style="margin-top: 15px;"
          class="focus"
          v-if="test && test.focus_elements && test.focus_elements.length > 0"
        >
          <bg-field class="field" label="Focus point">
            <bg-select
              :extraWide="true"
              @change="selectFocus"
              :options="test.focus_elements"
              :value="selectedInsight.focus_point"
              :clearable="true"
              label="focus_point"
            ></bg-select>
          </bg-field>
        </div>
        <div class="columns">
          <div class="left">
            <Editor
              :whiteBackground="true"
              :loadContent="selectedInsight.explanation"
              @update="updateExplanation"
              title="Explanation"
              ref="explanation"
              @chatgpt="
                background.modal = true;
                background.text = selectedInsight.explanation;
                background.element = 'explanation';
              "
            >
            </Editor>

            <Editor
              ref="summary"
              :whiteBackground="true"
              :loadContent="selectedInsight.summary"
              @update="updateSummary"
              title="Summary"
            >
            </Editor>
          </div>
          <div class="right">
            <div class="suggestions">
              <Editor
                :whiteBackground="true"
                :loadContent="selectedInsight.suggestion"
                @update="updateSuggestion"
                title="Suggestions"
                v-if="
                  selectedInsight.suggestion != '' &&
                    selectedInsight.suggestion != '<p></p>'
                "
              >
              </Editor>
              <div
                v-else
                style="display: flex; flex-direction: column; gap: 10px;"
              >
                <Editor
                  :whiteBackground="true"
                  @update="updateNewSuggestion"
                  title="Suggestions"
                  ref="newSug"
                >
                </Editor>
                <input
                  type="text"
                  v-model="suggestion.title"
                  placeholder="Title"
                />
                <div class="buttons">
                  <bg-button
                    text="Add suggestion"
                    @click="addSuggestion"
                  ></bg-button>
                  <bg-button
                    text="See all suggestions"
                    variant="secondary"
                    @click="
                      $router.push(`/test/${$route.params.id}/suggestions`)
                    "
                  ></bg-button>
                </div>
              </div>

              <div
                class="suggestion-row"
                v-for="(suggestion, index) in filtered"
                :key="index"
              >
                <div class="left-sug">
                  <p style="font-weight: 600" v-html="suggestion.title"></p>
                  <p v-html="suggestion.suggestion"></p>
                </div>
                <div class="remove" @click="removeSuggestion(suggestion.id)">
                  <bg-icon name="fdelete"></bg-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <div>
            <Editor
              :whiteBackground="true"
              :loadContent="selectedInsight.eeg_comment"
              @update="updateEeg"
              title="EEG"
            >
            </Editor>
          </div>
          <div>
            <Editor
              :whiteBackground="true"
              v-if="device === 'desktop'"
              :loadContent="selectedInsight.eye_tracking_comment"
              @update="updateEye"
              title="Eye"
            >
            </Editor>
            <Editor
              :whiteBackground="true"
              v-if="device === 'mobile'"
              :loadContent="selectedInsight.touch_tracking_comment"
              @update="updateTouch"
              title="Touch"
            >
            </Editor>
          </div>
          <div>
            <Editor
              :whiteBackground="true"
              :loadContent="selectedInsight.behavior_comment"
              @update="updateBehavior"
              title="Behavior"
            >
            </Editor>
          </div>
        </div>
        <div class="datapoints" v-if="!loading">
          <div
            style="display: flex; align-items: center; justify-content: space-between"
          >
            <p><b>Supporting data</b></p>
            <p
              style="cursor: pointer; font-size: 10pt; "
              @click="
                $store.commit(
                  'SET_TEST_TRANSLATION',
                  !$store.state.test.translation
                )
              "
            >
              <u>
                {{
                  $store.state.test.translation
                    ? "Original"
                    : $store.state.test.translation_language
                }}</u
              >
            </p>
          </div>
          <p v-if="selectedInsight.significant_points.length === 0">
            Start adding datapoints by assigning them to this insight.
          </p>
          <p>First one is the highlighted one.</p>
          <draggable
            group="all"
            :list="selectedInsight.significant_points"
            @end="onEnd"
            :animation="200"
            @change="log"
            id="sps"
            ghost-class="ghost-card"
          >
            <bg-detail-card
              v-for="(detail, index) in selectedInsight.significant_points"
              :key="detail.detail"
              v-bind="{ ...detail }"
              :text="
                $store.state.test.translation
                  ? detail.translation
                  : detail.comment
              "
              :detail="detail.emotion"
              @click.native="handleTimeClick(detail)"
              actionIcon="videos"
              actionText="Watch recording"
              :actionTextTarget="`Participant ${detail.participant_id}`"
              :class="{ active: index === 0 }"
            />
          </draggable>
          <div class="hr">
            <draggable
              group="all"
              :list="deletedSps"
              :animation="200"
              id="deleted"
              :style="{
                top: bTop - 10 + 'px',
              }"
            >
            </draggable>
          </div>
        </div>
      </div>

      <div class="suggestions" v-if="suggestionMode">
        <List
          :items="suggestions"
          headers="headers2"
          :newInsight="addInsight"
          :select="selectInsight"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import List from "./list";
import BgTypography from "@/directives/bg-typography";
import BgDetailCard from "@/components/bg-detail-card";
import API from "@/api";
import Draggable from "vuedraggable";
import Editor from "../editor";
import BgIcon from "@/components/bg-icon";
import BgButton from "@/components/bg-button";
import summarizeInsight from "@/mixins/GenerateInsight.js";
import generateSuggestions from "@/mixins/GenerateInsight.js";
import explanation from "@/mixins/GenerateInsight.js";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgSelect from "@/components/bg-select";
import BgModalChat from "@/components/bg-modal-chat";

export default {
  props: ["isLoading", "selectFeedback"],
  components: {
    BgInput,
    BgModalChat,
    List,
    BgDetailCard,
    Draggable,
    Editor,
    BgIcon,
    BgButton,
    BgField,
    BgSelect,
  },
  created() {
    this.fetchData();
  },
  computed: {
    insightTitle: function() {
      if (!this.selectedInsight.title) return "Enter a title here";
      return this.selectedInsight.title;
    },
    filtered() {
      return this.suggestions.filter(
        (el) => el.insight_id === this.selectedInsight.id
      );
    },
  },
  directives: {
    BgTypography,
  },
  mixins: [summarizeInsight, generateSuggestions, explanation],
  data() {
    return {
      actions: [],
      background: {
        modal: false,
        element: "explanation",
        text: "",
      },
      bTop: 10,
      deletedSps: [],
      device: null,
      editName: false,

      headers: [
        { label: "Name", value: "name" },
        { label: "Suggestions", value: "suggestions" },
        { label: "Datapoints2", value: "datapoints" },
      ],
      headers2: [
        { label: "Title", value: "title" },
        { label: "Author", value: "author" },
      ],
      image: "",
      insights: [],
      listMode: true,
      loading: false,
      loading_explanation: false,
      loading_summary: false,
      loading_suggestion: false,
      savingDone: false,
      selectedInsight: null,
      suggestionMode: false,
      suggestion: {
        title: "",
        suggestion: "",
      },
      suggestions: [],
      typing: false,
      test: null,
      deleting: false,
    };
  },
  watch: {
    insights: function() {
      this.$emit("change", this.insights);
      let i;
      for (i = 0; i < this.insights.length; i++) {
        this.insights[i].assigned_id = i + 1;
      }
      this.insights.forEach((obj) => {
        API.test.updateInsight(this.$route.params.id, obj.id, obj);
      });
    },
  },
  methods: {
    async addInsight(val) {
      await API.test.createInsight(this.$route.params.id, val);
      const res2 = await API.test.getInsights(this.$route.params.id);
      this.insights = [];
      res2.data.insights.forEach((el) => {
        this.insights.push(el);
      });
      this.$emit("change", this.insights);

      const latest = await this.insights.reduce(function(prev, current) {
        return prev.id > current.id ? prev : current;
      });
      this.selectedInsight = latest;
      this.listMode = false;
    },
    async addSuggestion() {
      this.suggestion.author_id = this.$store.state.user.user.id;
      this.suggestion.test_id = this.$route.params.id;
      this.suggestion.insight_id = this.selectedInsight.id;
      const newSuggestions = await API.test.createSuggestion(this.suggestion);
      this.suggestions = newSuggestions.suggestions;
      this.suggestion = { title: "", suggestion: "" };
      this.$refs.newSug.clearEditor();
    },
    addSP(val) {
      function id(insights) {
        return val.insightId === insights.id;
      }

      if (!this.insights.find(id).significant_points_ids.includes(val.id)) {
        this.insights.find(id).significant_points.push({
          comment: val.comment,
          emotion: val.emotion,
          id: val.id,
          participant_id: val.pp_id,
          ranking: val.ranking,
          score: val.score,
          timestamp_top: val.timestamp_top,
        });

        if (!this.insights.find(id).highlight_id) {
          this.insights.find(id).highlight_id = val.id;
        }

        this.insights.find(id).significant_points_ids.push(val.id);
        API.test.updateInsight(
          this.$route.params.id,
          val.insightId,
          this.insights.find(id)
        );
      }
      this.savingDone = true;
      setTimeout(() => (this.savingDone = false), 3000);
    },

    async deleteInsight() {
      let r = confirm("Are you sure?!");
      if (r == true) {
        await API.test.deleteInsight(
          this.$route.params.id,
          this.selectedInsight.id
        );
        this.listMode = true;
        this.fetchData();
      }
    },
    async explain() {
      let r = false;
      if (
        !this.selectedInsight.explanation ||
        this.selectedInsight.explanation === "<p></p>"
      ) {
        r = true;
      } else {
        r = confirm(
          "This will overwrite your existing explanation. Do you want to proceed?"
        );
      }
      if (r) {
        this.loading_explanation = true;
        const res = await this.explanation(
          this.selectedInsight.significant_points_ids,
          this.selectedInsight.title,
          this.selectedInsight.focus_point
            ? this.selectedInsight.focus_point
            : null
        );
        this.updateExplanation(res);
        const child = this.$refs.explanation;
        child.setContent(res);
        this.loading_explanation = false;
      }
    },
    async fetchData() {
      this.insights = [];
      const res = await API.test.getInsights(this.$route.params.id);
      res.data.insights.forEach((el) => {
        this.insights.push(el);
      });
      const suggestions = await API.test.getSuggestions(this.$route.params.id);
      this.suggestions = suggestions.suggestions;

      this.$emit("change", this.insights);

      const test = await API.test.getTest(this.$route.params.id);
      this.test = test;
      this.device = test.platform;
    },
    async generateSuggestion() {
      this.loading_suggestion = true;
      const res = await this.generateSuggestions(
        this.selectedInsight.explanation
      );
      res.forEach(async (s) => {
        let suggestion = {
          title: s.title,
          suggestion: s.suggestion,
          author_id: this.$store.state.user.user.id,
          test_id: this.$route.params.id,
          insight_id: this.selectedInsight.id,
        };

        const sug = await API.test.createSuggestion(suggestion);
        this.suggestions.push(sug);
        this.suggestion = { title: "", suggestion: "" };
        this.$refs.newSug.clearEditor();
        this.loading_suggestion = false;
      });
    },
    handleTimeClick(detail) {
      this.selectFeedback(detail);
    },
    log() {
      this.savingDone = false;
      // see if highlighted changed
      let newHigh;
      let oldHigh;
      if (this.selectedInsight.significant_points.length > 0) {
        newHigh = this.selectedInsight.significant_points[0].id;
        oldHigh = this.selectedInsight.highlight_id;
      }
      const changed = newHigh != oldHigh;
      if (changed) {
        this.selectedInsight.highlight_id = newHigh;
      }

      // remove from sp-id's if deleted one sp
      if (
        this.selectedInsight.significant_points_ids.length >
        this.selectedInsight.significant_points.length
      ) {
        this.deletedSps.forEach((el) => {
          const index = this.selectedInsight.significant_points_ids.findIndex(
            (sp) => sp === el.id
          );
          if (index > -1) {
            this.selectedInsight.significant_points_ids.splice(index, 1);
          }
        });
        this.deleting = false;
      }
      this.saveInsight();
    },
    onEnd: function(evt) {},
    async onFileChange(e) {
      const fileBase64 = await this.toBase64(this.$refs.imageRef.files[0]);
      this.selectedInsight.highlight = fileBase64;
      this.selectedInsight.highlight_url = fileBase64;
      this.saveInsight();
    },
    openImage() {
      window.open(this.selectedInsight.highlight_url, "_blank");
    },
    open(id) {
      this.listMode = false;
      this.selectedInsight = this.insights.find((i) => i.id === id);
    },
    async removeSuggestion(id) {
      let r = confirm("Are you sure?!");
      if (r == true) {
        await API.test.deleteSuggestion(this.$route.params.id, id);
        this.suggestions.splice(
          this.suggestions.findIndex((el) => el.id === id),
          1
        );
      }
    },
    saveInsight() {
      API.test.updateInsight(
        this.$route.params.id,
        this.selectedInsight.id,
        this.selectedInsight
      );
      this.savingDone = true;
      setTimeout(() => (this.savingDone = false), 3000);
    },
    selectFocus(i) {
      this.selectedInsight.focus_point = i;
      this.saveInsight();
    },
    setResult(v) {
      this.background.modal = false;
      this.selectedInsight[this.background.element] = v;
      this.background = {
        modal: false,
        element: "",
        text: "",
      };
    },
    async summarize() {
      let r = false;
      if (
        !this.selectedInsight.explanation ||
        this.selectedInsight.explanation === "<p></p>"
      ) {
        r = true;
      } else {
        r = confirm(
          "This will overwrite your existing explanation. Do you want to proceed?"
        );
      }
      if (r) {
        this.loading_summary = true;
        const res = await this.summarizeInsight(
          this.selectedInsight.explanation
        );
        this.updateSummary(res);
        const child = this.$refs.summary;
        child.setContent(res);
        this.loading_summary = false;
      }
    },
    showInput() {
      // Show the input component
      this.editName = true;

      // Focus the component, but we have to wait
      // so that it will be showing first.
      this.$nextTick(() => {
        this.focusInput();
      });
    },
    focusInput() {
      this.$refs.insightName.focus();
    },
    async selectInsight(val) {
      this.loading = true;

      if (!this.selectedInsight) {
        this.selectedInsight = this.insights[val];
      }
      if (this.selectedInsight.id != this.insights[val].id) {
        this.selectedInsight = this.insights[val];
      }
      this.listMode = false;
      let first = this.selectedInsight.highlight_id;
      this.selectedInsight.significant_points_ids.sort(function(x, y) {
        return x == first ? -1 : y == first ? 1 : 0;
      });

      // sorting the sp's so that the highlighted one is show as first in the list
      this.selectedInsight.significant_points.sort(function(x, y) {
        return x.id == first ? -1 : y.id == first ? 1 : 0;
      });

      this.loading = false;
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    updateExplanation(val) {
      this.selectedInsight.explanation = val;
      this.saveInsight();
    },
    updateSuggestion(val) {
      this.selectedInsight.suggestion = val;
      this.saveInsight();
    },
    updateNewSuggestion(val) {
      this.suggestion.suggestion = val;
    },
    updateSummary(val) {
      this.selectedInsight.summary = val;
      this.saveInsight();
    },
    updateEeg(val) {
      this.selectedInsight.eeg_comment = val;
      this.saveInsight();
    },
    updateEye(val) {
      this.selectedInsight.eye_tracking_comment = val;
      this.saveInsight();
    },
    updateTouch(val) {
      this.selectedInsight.touch_tracking_comment = val;
      this.saveInsight();
    },
    updateBehavior(val) {
      this.selectedInsight.behavior_comment = val;
      this.saveInsight();
    },
  },
};
</script>
